/* @jsx h */
import { defineComponent, h } from "vue";

export type GiftCardSectionProps = {
  icon: string;
  title: string;
  /** Short text on the right of the title, e.g. a count. */
  aside?: string;
};

/** A titled block of the GiftCardModal. */
export const GiftCardSection = defineComponent<GiftCardSectionProps>({
  name: "GiftCardSection",
  props: ["icon", "title", "aside"],
  setup(props, { slots }) {
    return () => (
      <section class="flex flex-col gap-2.5">
        <div class="flex items-center justify-between gap-2">
          <h3 class="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wider text-accent">
            <span class="material-symbols-outlined text-base">{props.icon}</span>
            {props.title}
          </h3>
          {props.aside ? (
            <span class="text-xs text-base-content/50">{props.aside}</span>
          ) : null}
        </div>
        {slots.default?.()}
      </section>
    );
  },
});
